import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import NotificationHistoryCard from '../../components/NotificationHistoryCard';
import { HostSettingsLayout } from '../../components/HostSettingsLayout';
import RoleNotificationPrefsCard from '../../components/RoleNotificationPrefsCard';
import { fetchAccountSettings, fetchNotificationHistory, updateAccountNotifications } from '../../utils/accountSettingsApi';

export default function GuestNotificationsPage() {
  const [notifications, setNotifications] = useState({});
  const [prefsConfig, setPrefsConfig] = useState({});
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [settings, historyItems] = await Promise.all([
          fetchAccountSettings(),
          fetchNotificationHistory({ scope: 'account' }),
        ]);
        setNotifications(settings.notifications || {});
        setPrefsConfig(settings.notification_prefs_config || {});
        setHistory(historyItems || []);
      } catch (error) {
        toast.error('Failed to load notification settings');
      }
    };
    load();
  }, []);

  // Auto-save: each toggle persists immediately (optimistic, with rollback
  // on failure). No "Done" button needed.
  const persist = async (next, previous) => {
    setNotifications(next);
    try {
      await updateAccountNotifications(next);
    } catch (error) {
      setNotifications(previous);
      toast.error(error.response?.data?.detail || 'Failed to update notifications');
    }
  };

  const handleToggle = (key) => {
    const current = notifications[key] !== false;
    const next = { ...notifications, [key]: !current };
    persist(next, notifications);
  };

  return (
    <HostSettingsLayout title="Notifications & History" dataTestId="guest-notifications-page">
      <RoleNotificationPrefsCard
        role="guest"
        config={prefsConfig}
        notifications={notifications}
        onToggle={handleToggle}
        testIdPrefix="guest-notifications-prefs"
      />

      <NotificationHistoryCard notifications={history} dataTestIdPrefix="guest-notifications-history" />
    </HostSettingsLayout>
  );
}
